import comp from "./StudentRoutineDetails";
export default comp;
